import React, { useState } from 'react'

import { PaginatedTable, PaginatedTableCallbacks } from '../common'
import { RecordsTable } from '.'
import { JsonRecord, Record } from '../../models'
import { getRecordsAssignedToUser } from '../../api'
import { getAuthUser } from '../../helpers'
import defineAbilityFor from './defineAbility'
import { InsufficientPermissions } from '../common'

export const RecordsAssignedToUser = () => {
    const ability = defineAbilityFor(getAuthUser())
    const [sortBy, setSortBy] = useState('AGENCY')
    const [sortDirection, setSortDirection] = useState('asc')

    if (!ability.can('View', 'Record')) {
        return <InsufficientPermissions />
    }

    const handleSortChange = (field: string) => {
        if (sortBy === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
        } else {
            setSortBy(field)
            setSortDirection('asc')
        }
    }

    return (
        <PaginatedTable<Record, JsonRecord>
            getData={(params) => getRecordsAssignedToUser({ ...params, sortBy, sortDirection })}
            modelConstructor={(json: JsonRecord) => new Record(json)}
            Table={(records: Record[], callbacks: PaginatedTableCallbacks) => (
                <RecordsTable
                    callbacks={callbacks}
                    resources={{ records }} />
            )}
            sortOptions={{
                sortBy,
                sortDirection,
                onSortChange: handleSortChange,
                sortFields: [
                    { field: 'AGENCY', label: 'Agency' },]
            }}
            title='Records Assigned to Me' />
    )
}
